export const schema = 'AutomationApps.Functions.Schedules.ControlledScheduler';